/**
 * Normalización y matching de transportadora → carrier de manifiestos
 */
import { MANIFIESTOS_CARRIERS } from '../../config/manifiestos/manifiestosCarriersConfig'
import type { ManifiestoCarrierConfig } from '../../types/manifiestos'

export function normalizeCarrierKey(value: string | null | undefined): string {
  if (value == null || typeof value !== 'string') return ''
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .replace(/-/g, '_')
}

/**
 * Resuelve un pedido.transportadora al carrier configurado del módulo
 */
export function matchManifiestoCarrier(
  transportadora: string | null | undefined
): ManifiestoCarrierConfig | null {
  const key = normalizeCarrierKey(transportadora)
  if (!key) return null

  return (
    MANIFIESTOS_CARRIERS.find((carrier) => {
      const valueKey = normalizeCarrierKey(carrier.transportadoraValue)
      if (valueKey && valueKey === key) return true
      return carrier.aliases.some(
        (alias) => normalizeCarrierKey(alias) === key
      )
    }) || null
  )
}

/**
 * Filtra pedidos de una sola consulta por carrier
 */
export function filterOrdersByCarrier(
  orders: unknown[],
  carrier: ManifiestoCarrierConfig
): unknown[] {
  return orders.filter((raw) => {
    const order = raw as { transportadora?: string }
    const matched = matchManifiestoCarrier(order.transportadora)
    return matched?.id === carrier.id
  })
}

/**
 * Cuenta pedidos por carrierId a partir de una lista ya cargada
 */
export function countOrdersByCarrier(
  orders: unknown[]
): Record<string, number> {
  const counts: Record<string, number> = {}
  MANIFIESTOS_CARRIERS.forEach((c) => {
    counts[c.id] = 0
  })

  orders.forEach((raw) => {
    const order = raw as { transportadora?: string }
    const matched = matchManifiestoCarrier(order.transportadora)
    if (matched) {
      counts[matched.id] = (counts[matched.id] || 0) + 1
    }
  })

  return counts
}
